import { cn } from "@/lib/utils/cn";

type NebulaBackgroundProps = {
  className?: string;
};

export const NebulaBackground: React.FC<NebulaBackgroundProps> = ({
  className,
}) => (
  <div
    className={cn("absolute inset-0 overflow-hidden", className)}
    aria-hidden="true"
  >
    <div className="nebula-haze absolute -left-[14%] top-[10%] h-[95%] w-[48%] rounded-full blur-3xl" />

    <div className="absolute inset-0 opacity-60">
      <div className="nebula-glow-blue absolute -inset-4 -right-32 opacity-40 blur-3xl" />
      <div className="nebula-glow-cyan absolute -inset-4 -left-32 opacity-40 blur-3xl" />
    </div>

    <div className="absolute inset-x-[20%] top-[58%] -bottom-[10%] opacity-45">
      <div className="nebula-glow-violet absolute -inset-8 -left-64 opacity-70 blur-3xl will-change-transform md:motion-safe:animate-[nebula-drift-a_20s_ease-in-out_infinite]" />
      <div className="nebula-glow-rose absolute -inset-8 left-64 -bottom-32 opacity-70 blur-3xl will-change-transform md:motion-safe:animate-[nebula-drift-b_24s_ease-in-out_infinite]" />
      <div className="nebula-glow-primary absolute -inset-8 opacity-60 blur-3xl will-change-transform md:motion-safe:animate-[nebula-drift-c_18s_ease-in-out_infinite]" />
    </div>

    <div className="nebula-planet absolute -right-[120px] top-[18%] hidden size-[300px] rounded-full sm:block md:-right-[90px]" />
  </div>
);
